import React, { Component } from "react";
import { Button, Col, Row } from "react-bootstrap";
import CustomPageHeader from "../fragments/CustomPageHeader";
import store from "store";
import FontAwesome from "react-fontawesome";
import { browserHistory } from "react-router";
import PhoneNumberForm from "./PhoneNumberForm";
import { blockingFetchService } from "../../lib/blockingFetch";
import authServerApi from "../../redux/sagas/authServerApi";
import Authenticated from "../../lib/Authenticated";

class MyAccount extends Component {

  SIXTY_SECONDS = 60;

  constructor(props) {

    super(props);
    this.authenticated = new Authenticated();
    this.currentSavedPhoneNumber = this.authenticated.getPhoneNumber();
    this.state = {
      show: false,
      phoneNumber: this.currentSavedPhoneNumber,
      isPhoneNumberChanged: false,
      operationNumber: 1,
      running: false,
      success: false,
      error: null,
      verificationCode: '',
      runningResend: false,
      successResend: false,
      resendText: false,
      retryIn: this.SIXTY_SECONDS,
    };
  }

  savePhoneNumber = phoneNumber => {

    this.setState({
      running: true,
      success: false,
      error: null
    });

    blockingFetchService(
      accessToken => authServerApi.updatePhoneNumber(accessToken, phoneNumber), 
      response => {
        store.set("userInfo", response);
        this.currentSavedPhoneNumber = response.phoneNumber;
        this.setState({ operationNumber: 2 });
        this.stopTimerResendCode();
        this.startTimerResendCode();
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    );

  }

  sendPhoneNumberValidationCode = code => {

    this.setState({
      running: true,
      success: false,
      error: null
    });

    blockingFetchService(
      accessToken => authServerApi.validatePhoneNumberCode(accessToken, code), 
      response => {

        store.set("userInfo", response);
        this.currentSavedPhoneNumber = response.phoneNumber;
        this.setState({ success: true });

        setTimeout( this.handleClose, 1200);
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    );

  }

  resendPhoneNumberVerifCode = () => {

    this.setState({
      running: false,
      success: false,
      error: null,
      runningResend: true
    });

    blockingFetchService(
      accessToken => authServerApi.resentPhoneNumberCode(accessToken), 
      _ => {
        this.setState({ successResend: true });
        this.startTimerResendCode();
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ runningResend: false })
    );
  }

  handleShow = (phoneNumber, operationNumber) => {

    this.setState({
      operationNumber,
      phoneNumber, 
      isPhoneNumberChanged: false,
      running: false,
      success: false,
      error: null,
      successResend: false,
      runningResend: false,
      verificationCode: '',
      show: true
    });

    if(operationNumber === 2) {
      this.stopTimerResendCode();
      this.startTimerResendCode();
    }
  }

  handleClose = () => this.setState({ show: false });

  phoneNumberChanged = newValue => {
    const hasChanged = newValue !== this.currentSavedPhoneNumber ? true : false;
    this.setState({ phoneNumber: newValue, isPhoneNumberChanged: hasChanged });
  }

  /**
   * Timer to resend the verification code
   */
  startTimerResendCode = () => {

    this.setState({ resendText: false, retryIn: this.SIXTY_SECONDS });
    this.timeoutResendCodeId = setInterval(() => {

      if(this.state.retryIn === 0) {
        this.setState({ resendText: true });
        this.stopTimerResendCode();
      }
      else {
        this.setState({ retryIn: this.state.retryIn - 1 });
      }
    }, 1000);
  }

  stopTimerResendCode = () => clearInterval(this.timeoutResendCodeId);

  renderPhoneNumber = (phoneNumber, mustVerifyPhoneNumber) => {

    const btn = phoneNumber ? 
      <span className='cursor-pointer' onClick={() => this.handleShow(phoneNumber, 1)} title='Update the phone number'>
        <FontAwesome name='pencil' size="lg"/>
      </span>
      :
      <span className='cursor-pointer' onClick={() => this.handleShow(null, 1)} title='Add a phone number'>
        <FontAwesome name='plus-circle' size="lg"/>
      </span>;

    const mustVerifyPhoneNumberMark = mustVerifyPhoneNumber ? 
      <span className='yellow' title="This phone number hasn't been verified yet!">
        <FontAwesome name='exclamation-triangle' size="lg"/>
      </span>
      :
      <span className='green' title='Well. This phone number has been verified.'>
        <FontAwesome name='check-circle' size="lg"/>
      </span>;

    const mustVerifyPhoneNumberAction =  
      <span id='verify-text-container'>
        <small
          className='cursor-pointer' 
          id='verify-text'
          onClick={() => this.handleShow(phoneNumber, 2)}
          title='Click to verify this phone number'>
          Click to verify
        </small>
      </span>;

    return (
      <div>
        { phoneNumber && mustVerifyPhoneNumberMark } { phoneNumber } &nbsp; { btn }
        { phoneNumber && mustVerifyPhoneNumber && mustVerifyPhoneNumberAction }
      </div>
    )
  }

  render() {

    const currentUser = store.get('userInfo');
    if(!currentUser) return null;

    const { error, isPhoneNumberChanged, operationNumber, phoneNumber, resendText, retryIn, running,
      runningResend, show, success, successResend, verificationCode } = this.state;

    return (
      <div>
        <CustomPageHeader icon='cog' text='My account' />
        <Row>
          <Col md={6}>

            <Row>
              <Col md={4}>
                <strong>Name</strong>
              </Col>
              <Col md={8}>
                { currentUser.name }
                <hr />
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <strong>Email</strong>
              </Col>
              <Col md={8}>
                { currentUser.username }
                <hr />
              </Col>
            </Row>

            <Row>

              <Col md={4}>

                <strong>Phone number</strong>

                <PhoneNumberForm
                  handleClose={ this.handleClose }
                  show={ show }
                  operationNumber={ operationNumber }
                  email={ currentUser.username }
                  phoneNumber={ phoneNumber }
                  savePhoneNumber={ this.savePhoneNumber }
                  setPhoneNumber={ this.phoneNumberChanged }
                  isPhoneNumberChanged={ isPhoneNumberChanged }
                  verificationCode={ verificationCode }
                  setVerificationCode={ verificationCode => this.setState({verificationCode}) }
                  sendPhoneNumberValidationCode={ this.sendPhoneNumberValidationCode }
                  title={ operationNumber === 2 ? 'Verify phone number' : currentUser.phoneNumber ? 'Update phone number' : 'Adding phone number' }
                  buttonText={ operationNumber === 2 ? 'Verify' : currentUser.phoneNumber ? 'Update' : 'Add' }
                  isProcessRunning={ running }
                  isProcessSuccessful={ success }
                  isProcessFailed={ error }
                  successResend={ successResend }
                  runningResend={ runningResend }
                  resendVerifCode={ () => this.resendPhoneNumberVerifCode() }
                  resendText={ resendText }
                  retryIn={ retryIn }
                />
              </Col>

              <Col md={8}>
                { this.renderPhoneNumber(currentUser.phoneNumber, currentUser.mustVerifyPhoneNumber) }
                <hr />
              </Col>

            </Row>

            <Row>
              <Col md={4}>
                <strong>Role</strong>
              </Col>
              <Col md={8}>
                { currentUser.userRole }
                <hr />
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <strong>Locale</strong>
              </Col>
              <Col md={8}>
                { currentUser.locale }
                <hr />
              </Col>
            </Row>

            { this.authenticated.isAdmin() ?
              <Row>
                <Col md={4}>
                </Col>
                <Col md={8}>
                  <Button bsStyle="success" onClick={() => browserHistory.push(`/users/${currentUser.id}/edit`)}>
                    Update my account
                  </Button>
                </Col>
              </Row> : null
            }

          </Col>

          <Col md={6}>

            <h4>Activities</h4>

            <Row>
              <Col md={4}>
                <strong>Last login</strong>
              </Col>
              <Col md={8}>
                { store.get('lastLogin') }
                <hr />
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    )
  }
}

export default MyAccount;



// WEBPACK FOOTER //
// ./src/components/MyAccount/index.js